<template>
  <div class="trail-episodes-list">
    <router-link
      v-for="video in videos"
      class="form-row align-items-center mb-3 text-decoration-none text-light"
      :key="video.id"
      :to="{ params: { id: video.id } }"
    >
      <div class="col-5">
        <img class="img-fluid" :src="img(video)" />
      </div>
      <div class="col-7">
        <div class="video-name">{{ video.name }}</div>
        <small class="text-secondary">{{ duration(video) }}</small>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    videos: Array
  },
  methods: {
    img(video) {
      return video.picture || video.thumbnail_vimeo;
    },
    duration(video) {
      const s = `${video.total_duration % 60}`.padStart(2, "0");
      const m = `${Math.floor(video.total_duration / 60)}`.padStart(2, "0");
      return `${m}:${s}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.trail-episodes-list {
  .video-name {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
}
</style>
